export const chart = {
  chartWithoutData: 'Sorry, there is \nno data available.',
  nationalAverage: 'monthly United Arab Emirates average',
};
